import axiosInstance from "./axiosInstance";

// 로컬: /api/v1 또는 "" (백엔드 경로에 맞게 설정)
// 배포: /api/_proxy/v1 (프록시 사용)
const API_PREFIX =
  process.env.REACT_APP_API_PREFIX ?? "/api/_proxy/v1";

// 로그인 (No Token)
export const login = async (email, password) => {
  return axiosInstance.post(
    `${API_PREFIX}/admin/auth/signin`,
    { email, password },
    { skipAuth: true }
  );
};

// 이메일 인증번호 발송 (No Token)
export const sendEmailCode = async (email) => {
  return axiosInstance.post(
    `${API_PREFIX}/auth/email/send`,
    { email },
    { skipAuth: true }
  );
};

// 회원가입 (No Token)
export const signup = async (data) => {
  return axiosInstance.post(`${API_PREFIX}/admin/auth/signup`, data, {
    skipAuth: true,
  });
};

// 어드민 비밀번호 찾기 (이메일 재설정 링크 발송, No Token)
export const forgotAdminPassword = async (email) => {
  return axiosInstance.post(
    `${API_PREFIX}/admin/auth/password/forgot`,
    { email },
    { skipAuth: true }
  );
};

// 비밀번호 재설정 수행 (토큰 기반, No Token)
export const resetPasswordByToken = async (token, newPassword) => {
  return axiosInstance.post(
    `${API_PREFIX}/auth/password/reset`,
    { token, newPassword },
    { skipAuth: true }
  );
};

// 계정 목록 조회 (Token 자동 포함)
export const accountList = async ({ role, page, size, status = "ACTIVE" }) => {
  const params = new URLSearchParams({
    role,
    page,
    size,
    status,
  });

  return axiosInstance.get(`${API_PREFIX}/admin/accounts?${params.toString()}`);
};

export const updateUserStatus = async ({ userId, status }) => {
  return axiosInstance.patch(`${API_PREFIX}/admin/accounts/users/${userId}/status`, {
    status,
  });
};

export const adminActionLogs = async ({
  page = 1,
  size = 20,
  adminUserId,
  actionType,
  targetType,
  targetId,
} = {}) => {
  const params = new URLSearchParams({
    page: String(page),
    size: String(size),
  });
  if (adminUserId) params.set("adminUserId", String(adminUserId));
  if (actionType) params.set("actionType", actionType);
  if (targetType) params.set("targetType", targetType);
  if (targetId) params.set("targetId", String(targetId));

  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/audit/action-logs?${params.toString()}`
  );
  return res.data;
};

// 사이드바 캠페인 조회
export const getSidebar = async () => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/sidebar/campaigns/count`
  );

  return res.data;
};

// 크리에이터 상세 조회
export const creatorDetail = async (id) => {
  return axiosInstance.get(`${API_PREFIX}/admin/accounts/creators/${id}`);
};

// 광고주 상세 조회
export const advertiserDetail = async (id) => {
  return axiosInstance.get(`${API_PREFIX}/admin/accounts/advertisers/${id}`);
};

// 결제대기 목록 조회
export const pendingPaymentList = async ({ page, size }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/campaigns/pending-payment?page=${page}&size=${size}`
  );

  return res.data;
};

// 모집중 목록 조회
export const recuruitingList = async ({ page, size }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/campaigns/recruiting?page=${page}&size=${size}`
  );

  return res.data;
};

// 제안진행중 목록 조회
export const offeringList = async ({ page, size }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/campaigns/offering?page=${page}&size=${size}`
  );

  return res.data;
};

// 완료 목록 조회
export const contractedList = async ({ page, size }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/campaigns/contracted?page=${page}&size=${size}`
  );

  return res.data;
};

// 결제 대기중 상세 조회
export const pendingPaymentDetail = async ({ id }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/campaigns/pending-payment/${id}`
  );

  return res.data;
};
// 모집중 상세 조회
export const recruitingDetail = async ({ id }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/campaigns/recruiting/${id}`
  );

  return res.data;
};

// 진행중 상세 조회
export const offeringDetail = async ({ id }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/campaigns/offering/${id}/creators`
  );

  return res.data;
};
// 모집완료 상세 조회
export const contractedDetail = async ({ id }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/campaigns/contracted/${id}/creators`
  );

  return res.data;
};

// CPS 캠페인 상품(뷰 전용)
export const cpsCampaignProductsView = async ({ campaignId }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/cps/campaigns/${campaignId}/products/view`
  );
  return res.data;
};

// 캠페인 제안서 생성
export const createProposal = async ({ id, body }) => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/admin/campaigns/${id}/proposal`,
    body
  );

  return res.data;
};

// 정산서 발행
export const createSettlement = async ({ id }) => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/admin/settlements/live-posts/${id}/request`
  );

  return res.data;
};

// 결제대기 -> 진행중 상태변경
export const campaignStatusChange = async ({ id }) => {
  const res = await axiosInstance.patch(
    `${API_PREFIX}/admin/campaigns/${id}/change-status`
  );
  return res.data;
};

// 캠페인 예산 결제
export const campaignPayment = async ({ id }) => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/admin/campaigns/${id}/payment/confirm`
  );
  return res.data;
};

export const adminHideCampaign = async ({ id }) => {
  const res = await axiosInstance.patch(`${API_PREFIX}/admin/campaigns/${id}/hide`);
  return res.data;
};

export const adminShowCampaign = async ({ id }) => {
  const res = await axiosInstance.patch(`${API_PREFIX}/admin/campaigns/${id}/show`);
  return res.data;
};

export const adminConfirmProposalCreators = async ({ proposalId, creatorProfileIds }) => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/admin/campaigns/offering/${proposalId}/confirmed`,
    { creatorProfileIds }
  );
  return res.data;
};

export const adminSkipCpsContentStep = async ({ campaignId }) => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/admin/campaigns/${campaignId}/cps/content-step/skip`
  );
  return res.data;
};

// 어드민 캠페인 수정 (결제 대기 / 모집중·신청자 0명만 가능, total_budget 제외)
export const updateCampaign = async (campaignId, body) => {
  const res = await axiosInstance.patch(
    `${API_PREFIX}/admin/campaigns/${campaignId}`,
    body
  );
  return res.data;
};

// 성과 측정 (대기중)
export const ResultWating = async () => {
  const res = await axiosInstance.get(`${API_PREFIX}/admin/live/waiting`);

  return res.data;
};

// 성과 측정 (진행중)
export const ResultOngoing = async () => {
  const res = await axiosInstance.get(`${API_PREFIX}/admin/live/ongoing`);

  return res.data;
};

// 성과 측정 (진행완료)
export const ResultClosing = async () => {
  const res = await axiosInstance.get(`${API_PREFIX}/admin/live/closing`);

  return res.data;
};

// 정산 및 종료 (대기중)
export const settlementWating = async () => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/settlements/waiting`
  );

  return res.data;
};

// 정산 및 종료 (완료)
export const settlementCompleted = async () => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/settlements/completed`
  );

  return res.data;
};

// 콘텐츠 모니터링 (검수중)
export const contentsReview = async () => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/proposals/under-review`
  );

  return res.data;
};

// 콘텐츠 모니터링 (검수대기)
export const contentsPending = async () => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/proposals/pending-submission`
  );

  return res.data;
};

// 콘텐츠 모니터링 (검수완료)
export const contentsCompletion = async () => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/proposals/completion`
  );

  return res.data;
};

// 콘텐츠 상세
export const contentsDetail = async (id) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/proposals/${id}/creators`
  );

  return res.data;
};

// 콘텐츠 상세 (크리에이터)
export const contentsCreatorDetail = async (proposalId, creatorId) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/proposals/${proposalId}/creators/${creatorId}/contents`
  );

  return res.data;
};

export const adminContentConfirm = async ({ proposalId, creatorId, contentId }) => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/admin/proposals/${proposalId}/creators/${creatorId}/contents/${contentId}/confirm`
  );
  return res.data;
};

export const adminContentReject = async ({ proposalId, creatorId, contentId }) => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/admin/proposals/${proposalId}/creators/${creatorId}/contents/${contentId}/reject`
  );
  return res.data;
};

export const adminContentFeedback = async ({ proposalId, creatorId, contentId, message }) => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/admin/proposals/${proposalId}/creators/${creatorId}/contents/${contentId}/feedback`,
    { message }
  );
  return res.data;
};

export const adminContentLiveSchedule = async ({
  proposalId,
  creatorId,
  contentId,
  startAt,
  endAt,
}) => {
  const res = await axiosInstance.patch(
    `${API_PREFIX}/admin/proposals/${proposalId}/creators/${creatorId}/contents/${contentId}/live-schedule`,
    { startAt, endAt }
  );
  return res.data;
};

// 공지사항 조회
export const noticeList = async ({ page, size }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/notices?targetType=ALL&includeDeleted=false&page=1&size=10`
  );

  return res.data;
};

// 공지사항 상세 조회
export const noticeDetail = async ({ id }) => {
  const res = await axiosInstance.get(`${API_PREFIX}/admin/notices/${id}`);

  return res.data;
};

// 공지사항 등록
export const createNotice = async ({ body }) => {
  const res = await axiosInstance.post(`${API_PREFIX}/admin/notices`, body);

  return res.data;
};

// 공지사항 수정
export const editNotice = async ({ id, body }) => {
  const res = await axiosInstance.put(
    `${API_PREFIX}/admin/notices/${id}`,
    body
  );

  return res.data;
};

// 공지사항 삭제
export const deleteNotice = async ({ id }) => {
  const res = await axiosInstance.delete(`${API_PREFIX}/admin/notices/${id}`);

  return res.data;
};

// 채팅방 생성
export const createChat = async ({ body }) => {
  const res = await axiosInstance.post(`${API_PREFIX}/admin/dm/rooms`, body);

  return res.data;
};

// 채팅방 목록 조회
export const chatList = async () => {
  const res = await axiosInstance.get(`${API_PREFIX}/admin/dm/rooms`);

  return res.data;
};

// 채팅방 상세 조회
export const chatDetailList = async ({ id }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/dm/rooms/${id}/messages`
  );

  return res.data;
};

// 채팅 보내기
export const sendChat = async ({ id, body }) => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/admin/dm/rooms/${id}/messages`,
    body
  );

  return res.data;
};

// 페르소나 생성
export const createPersona = async ({ platform, profileId }) => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/persona/${platform}/creators/${profileId}/create`
  );

  return res.data;
};

// 페르소나 패치
export const patchPersona = async ({ campaignId, profileId, personaId }) => {
  const res = await axiosInstance.patch(
    `${API_PREFIX}/admin/campaigns/${campaignId}/creators/${profileId}/update-persona?personaId=${personaId}`
  );

  return res.data;
};

// 페르소나 상태 변경
export const personaStatus = async ({ platform, profileId, personaId }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/persona/${platform}/creators/${profileId}/personas/${personaId}/status`
  );

  return res.data;
};

// 페르소나 최신 DB 상태 조회
export const latestPersonaStatus = async ({ platform, profileId }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/persona/${platform}/creators/${profileId}/status`
  );

  return res.data;
};

// 페르소나 상세 조회
export const personaDeatil = async ({ platform, profileId, personaId }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/persona/${platform}/creators/${profileId}/personas/${personaId}/detail`
  );

  return res.data;
};

// 콘텐츠 생성
export const createContents = async ({ campaignId, profileId, platform }) => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/campaigns/${campaignId}/creators/${profileId}/content-plan/create?platform=${platform}`
  );

  return res.data;
};

// 콘텐츠 패치
export const patchContents = async ({ campaignId, profileId, contentId }) => {
  const res = await axiosInstance.patch(
    `${API_PREFIX}/admin/campaigns/${campaignId}/creators/${profileId}/update-content-plan?contentPlanId=${contentId}`
  );

  return res.data;
};

// 콘텐츠 기획안 상태 변경
export const contentsStatus = async ({ campaignId, profileId, contentId }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/campaigns/${campaignId}/creators/${profileId}/content-plan/generations/${contentId}/status`
  );

  return res.data;
};

// 콘텐츠 기획안 목록 DB 상태 조회
export const contentJobList = async ({ campaignId, profileId }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/campaigns/${campaignId}/creators/${profileId}/content-plan/job-list`
  );

  return res.data;
};

// 콘텐츠 조회
export const contentDetail = async ({ campaignId, profileId, contentId }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/campaigns/${campaignId}/creators/${profileId}/content-plan/generations/${contentId}/detail`
  );

  return res.data;
};

// 계정 점수 조회
export const creatorScore = async ({ profileId }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/public/creators/${profileId}/activity-scores`
  );

  return res.data;
};

// 브랜드 적합도 생성
export const createRank = async ({ campaignId }) => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/campaigns/${campaignId}/persona-rank`
  );

  return res.data;
};

// 적합도 상태 변경
export const rankStatus = async ({ campaignId }) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/campaigns/${campaignId}/persona-rank/status`
  );

  return res.data;
};

// ── 인스타그램 프로필 (크롤링 데이터) ──

// 태그(카테고리) 목록 조회
export const instagramProfilesTags = async () => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/instagram-profiles/tags`
  );
  return res.data;
};

// 프로필 목록 조회 (목록용 최소 필드)
export const instagramProfilesList = async ({
  page = 1,
  size = 20,
  tagIds,
  keyword,
}) => {
  const params = new URLSearchParams({ page, size });
  if (tagIds?.length) params.append("tagIds", tagIds.join(","));
  if (keyword) params.append("keyword", keyword);

  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/instagram-profiles?${params.toString()}`
  );
  return res.data;
};

// 프로필 상세 조회 (클릭 시 전체 필드)
export const instagramProfileDetail = async (id) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/instagram-profiles/${id}`
  );
  return res.data;
};

// ── 스크래퍼 (스케줄 & 수집 로그) ──
const scraperBase = `${API_PREFIX}/admin/scraper`;

// 월별 스케줄 조회
export const scraperSchedulesMonthly = async ({ year, month }) => {
  const res = await axiosInstance.get(
    `${scraperBase}/calendar/monthly?year=${year}&month=${month}`
  );
  return res.data;
};

// 오늘의 스케줄 조회
export const scraperSchedulesToday = async () => {
  const res = await axiosInstance.get(`${scraperBase}/calendar/today`);
  return res.data;
};

// 스케줄 생성
export const scraperScheduleCreate = async (body) => {
  const res = await axiosInstance.post(`${scraperBase}/calendar/schedule`, body);
  return res.data;
};

// 해시태그 수정
export const scraperScheduleUpdateHashtags = async (id, hashtags) => {
  const params = new URLSearchParams();
  hashtags.forEach((t) => params.append("hashtags", t));
  const res = await axiosInstance.put(
    `${scraperBase}/calendar/schedule/${id}/hashtags?${params.toString()}`
  );
  return res.data;
};

// 실행 시간 수정
export const scraperScheduleUpdateTime = async (id, executionTime) => {
  const res = await axiosInstance.put(
    `${scraperBase}/calendar/schedule/${id}/time?executionTime=${encodeURIComponent(executionTime)}`
  );
  return res.data;
};

// 활성/비활성 토글
export const scraperScheduleToggle = async (id) => {
  const res = await axiosInstance.put(
    `${scraperBase}/calendar/schedule/${id}/toggle`
  );
  return res.data;
};

// 스케줄 삭제
export const scraperScheduleDelete = async (id) => {
  const res = await axiosInstance.delete(
    `${scraperBase}/calendar/schedule/${id}`
  );
  return res.data;
};

// 스케줄 통계
export const scraperScheduleStats = async () => {
  const res = await axiosInstance.get(`${scraperBase}/calendar/stats`);
  return res.data;
};

// 수집 로그 목록
export const scraperRunLogs = async ({
  skip = 0,
  limit = 20,
  status,
  scheduleId,
}) => {
  const params = new URLSearchParams({ skip, limit });
  if (status) params.append("status", status);
  if (scheduleId) params.append("scheduleId", scheduleId);
  const res = await axiosInstance.get(
    `${scraperBase}/run-logs?${params.toString()}`
  );
  return res.data;
};

// 수집 로그 상세
export const scraperRunLogDetail = async (id) => {
  const res = await axiosInstance.get(`${scraperBase}/run-logs/${id}`);
  return res.data;
};

// CPS 커미션 (어드민)
export const cpsAdminCommissionsList = async ({ status, limit } = {}) => {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  if (limit != null) params.set("limit", String(limit));
  const q = params.toString();
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/cps/commissions${q ? `?${q}` : ""}`
  );
  return res.data;
};

export const cpsAdminCommissionCampaigns = async () => {
  const res = await axiosInstance.get(`${API_PREFIX}/admin/cps/commissions/campaigns`);
  return res.data;
};

export const cpsAdminCommissionCreators = async (campaignId) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/cps/commissions/campaigns/${campaignId}/creators`
  );
  return res.data;
};

export const cpsAdminCommissionOrders = async (campaignId, creatorProfileId) => {
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/cps/commissions/campaigns/${campaignId}/creators/${creatorProfileId}/orders`
  );
  return res.data;
};

export const cpsAdminCommissionPay = async (id, manuscriptFeeApproved) => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/admin/cps/commissions/${id}/pay`,
    manuscriptFeeApproved == null
      ? {}
      : { manuscriptFeeApproved: Number(manuscriptFeeApproved) }
  );
  return res.data;
};

export const cpsAdminCommissionCancel = async (id, reason) => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/admin/cps/commissions/${id}/cancel`,
    reason ? { reason } : {}
  );
  return res.data;
};

/** 스케줄러와 동일: PENDING → CONFIRMED 배치 1회 (로컬 검증용) */
export const runCpsCommissionConfirmBatch = async () => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/admin/cps/commissions/actions/confirm-pending`
  );
  return res.data;
};

/** @deprecated 이름 통일용 별칭 — {@link runCpsCommissionConfirmBatch} 사용 권장 */
export const cpsAdminCommissionConfirmPendingBatch = runCpsCommissionConfirmBatch;

// CPS 캠페인 정산서 (어드민)
export const cpsAdminSettlementsList = async ({ status, limit } = {}) => {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  if (limit != null) params.set("limit", String(limit));
  const q = params.toString();
  const res = await axiosInstance.get(
    `${API_PREFIX}/admin/cps/settlements${q ? `?${q}` : ""}`
  );
  return res.data;
};

export const cpsAdminSettlementDetail = async (id) => {
  const res = await axiosInstance.get(`${API_PREFIX}/admin/cps/settlements/${id}`);
  return res.data;
};

export const cpsAdminSettlementRequest = async (id) => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/admin/cps/settlements/${id}/request`
  );
  return res.data;
};

export const cpsAdminSettlementCancel = async (id) => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/admin/cps/settlements/${id}/cancel`
  );
  return res.data;
};

// CPS 정산서 커미션 일괄 지급
export const cpsAdminSettlementPayCommissions = async (id) => {
  const res = await axiosInstance.post(
    `${API_PREFIX}/admin/cps/settlements/${id}/pay-commissions`,
    {}
  );
  return res.data;
};
